import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { MdDownloadForOffline } from "react-icons/md";
import config from "../config";
import Swal from "sweetalert2";
import CryptoJS from "crypto-js";

function SecondaryLanding() {
  const navigate = useNavigate();
  const [notices, setNotices] = useState([]);
  const [tickerData, setTickerData] = useState({});
  const [fileSizes, setFileSizes] = useState({});

  const SECRET_KEY = config.SECRET_KEY;
  function generateOneTimeToken() {
    const timestamp = Date.now();
    const nonce = CryptoJS.lib.WordArray.random(16).toString();
    const payload = `${timestamp}:${nonce}`;
    const signature = CryptoJS.HmacSHA256(payload, SECRET_KEY).toString();

    return `${timestamp}:${nonce}:${signature}`;
  }
  const fetchData = async () => {
    try {
      const tokeng = generateOneTimeToken();
      const response = await fetch(
        `${config.API_BASE_URL}/AdminFetchLandingPageData`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "X-Private-Key": tokeng,
          },
        }
      );

      const data = await response.json();

      if (response.ok) {
        setNotices(data.data.noticelist || []);
        setTickerData(data.data.titleDetails || {});
      } else {
        Swal.fire("Error", "Something went wrong", "error");
      }
    } catch (error) {
      console.error("Error fetching school:", error);
      Swal.fire("Error", "Something went wrong", "error");
    }
  };

  useEffect(() => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "/assets/css/landing.css";
    document.head.appendChild(link);

    fetchData();

    return () => {
      document.head.removeChild(link);
    };
  }, []);

  useEffect(() => {
    // console.log("Notices:", notices);
    const fetchFileSizesSequentially = async () => {
      const sizes = {};

      for (let index = 0; index < notices.length; index++) {
        const notice = notices[index];

        if (notice.noticE_FILE_URL) {
          try {
            const response = await fetch(notice.noticE_FILE_URL, {
              method: "HEAD",
            });
            const size = response.headers.get("Content-Length");
            sizes[index] = size ? (parseInt(size) / 1024).toFixed(2) : "0.00";
          } catch (err) {
            console.error(`Error fetching size for notice ${index}:`, err);
            sizes[index] = "0.00";
          }
        } else {
          sizes[index] = "0.00";
        }
      }

      setFileSizes(sizes);
    };

    if (Array.isArray(notices)) {
      fetchFileSizesSequentially();
    } else {
      console.warn("Notices is not a valid array:", notices);
      setFileSizes({});
    }
  }, [notices]);

  return (
    <>
      <div
        style={{ height: "100vh", display: "flex", flexDirection: "column" }}
      >
        <div style={{ flex: "1" }}>
          <header id="header">
            <div
              className="background"
              style={{
                height: 340,
                backgroundImage: "url(assets/images/jac-banner-1.jpg)",
                backgroundPosition: "center",
                backgroundSize: "cover",
                position: "relative",
              }}
            >
              <div className="container">
                <div
                  style={{ display: "flex", paddingTop: 130 }}
                  className="logo-div"
                >
                  <div>
                    <img
                      alt="no preview"
                      className="logo-img"
                      src="assets/images/jac.png"
                      height="120px"
                      style={{ marginRight: 30 }}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                    }}
                  >
                    <h1 className="jac-text" style={{ color: "white" }}>
                      Jharkhand Academic Council
                    </h1>
                    <h4 className="exam-text" style={{ color: "white" }}>
                      Secondary Registration & Examination Portal
                    </h4>
                  </div>
                </div>
              </div>
              {tickerData.title && (
                <div
                  style={{
                    position: "absolute",
                    bottom: "30px",
                    width: "100%",
                  }}
                >
                  <div
                    className="header"
                    style={{ width: "63%", marginLeft: "5%" }}
                  >
                    <marquee
                      className="marq"
                      direction="left"
                      style={{
                        color: "white",
                        fontWeight: 500,
                        padding: 10,
                        borderRadius: 10,
                        fontSize: 20,
                      }}
                    >
                      {tickerData.title}
                    </marquee>
                  </div>
                </div>
              )}
            </div>
          </header>

          {/* <nav className="navbar">
        <div className="navbar-container container">
          <div>
            <input type="checkbox" />
            <div className="hamburger-lines">
              <span className="line line1" />
              <span className="line line2" />
              <span className="line line3" />
            </div>
            <ul className="menu-items">
              <li>
                <a href="#" id="home-link" className="active">
                  Home
                </a>
              </li>
              <li>
                <a href="#" id="about-link">
                  About
                </a>
              </li>
              <li>
                <a href="#" id="contact-link">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav> */}

          <div className="container">
            <div className="testimonial-slider">
              <div
                id="carouselExampleControls"
                className="carousel carousel-dark"
              >
                <div className="container-fluid">
                  <div className="row mb-5">
                    {/* <h2 style={{ color: "black" }}>Important Links</h2> */}
                    <h2 style={{ color: "black" }}>Service Portals</h2>
                    <hr></hr>

                    <div className="col-md-3">
                      <div
                        style={{ marginTop: "15px", marginLeft: "10px" }}
                      ></div>
                      <a
                        style={{
                          height: "100px",
                          fontSize: "18px",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                        }}
                        className="btn mb-3 landing-button"
                        href="https://jacexamportal.in/notice.html"
                      >
                        Download <br></br>Examination Forms
                      </a>
                    </div>

                    <div className="col-md-3">
                      <div
                        style={{ marginTop: "15px", marginLeft: "10px" }}
                      ></div>
                      <a
                        style={{
                          height: "100px",
                          fontSize: "18px",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                        }}
                        className="btn mb-3 landing-button"
                        href="https://board-nine.jacexamonline.com/"
                      >
                        PORTAL FOR CLASS 9<br></br> (SECONDARY)<br></br> REGISTRATION 2026
                      </a>
                    </div>
                    <div className="col-md-3">
                      <div
                        style={{ marginTop: "15px", marginLeft: "10px" }}
                      ></div>
                      <a
                        style={{
                          height: "100px",
                          fontSize: "18px",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                        }}
                        className="btn mb-3 landing-button"
                        href="https://board-ten.jacexamonline.com/"
                      >
                        PORTAL FOR CLASS 10<br></br> (SECONDARY)<br></br> EXAMINATION 2026
                      </a>
                    </div>
                    {/* <div className="col-md-3">
                      <div
                        style={{ marginTop: "15px", marginLeft: "10px" }}
                      ></div>
                      <a
                        style={{
                          height: "100px",
                          fontSize: "18px",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                        }}
                        className="btn mb-3 landing-button"
                        href="https://class-nine-correction-portal.jacexamonline.com"
                      >
                       CLASS 9 STUDENT DATA<br></br> CORRECTION PORTAL
                      </a>
                    </div>  */}
                    {/* {sessionStorage.getItem("correctionstatus_firstpage_10") === "ON" && ( */}
                   {/* <div className="col-md-3">
                      <div
                        style={{ marginTop: "15px", marginLeft: "10px" }}
                      ></div>
                      <a
                        style={{
                          height: "100px",
                          fontSize: "18px",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                        }}
                        className="btn mb-3 landing-button"
                        href="https://secondary-correction-portal.jacexamonline.com"
                      >
                       CLASS 10 STUDENT DATA<br></br> CORRECTION PORTAL
                      </a>
                    </div> */}
                    {/* )} */}
                    {/* <div className="col-md-3">
                      <div
                        style={{ marginTop: "15px", marginLeft: "10px" }}
                      ></div>
                      <a
                        style={{
                          height: "100px",
                          fontSize: "18px",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                        }}
                        className="btn mb-3 landing-button"
                        href="https://board-nine.jacexamonline.com"
                      >
                        Class IX <br></br>Registration Portal
                      </a>
                    </div> */}
                    {/* <div className="col-md-3">
                      <div
                        style={{ marginTop: "15px", marginLeft: "10px" }}
                      ></div>
                      <a
                        style={{
                          height: "100px",
                          fontSize: "18px",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                        }}
                        className="btn mb-3 landing-button"
                        href="https://board-ten.jacexamonline.com"
                      >
                        Class X <br></br>Examination Portal
                      </a>
                    </div> */}
                    {/* <div className="col-md-3">
                  <div style={{ marginTop: "15px", marginLeft: "10px" }}></div>
                  <a
                    href=""
                    style={{
                      height: "100px",
                      fontSize: "18px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                    }}
                    className="btn mb-3 landing-button"
                  >
                    Secondary Correction<br></br> Portal
                  </a>
                </div>
                <div className="col-md-3">
                  <div style={{ marginTop: "15px", marginLeft: "10px" }}></div>
                  <a
                    href=""
                    style={{
                      height: "100px",
                      fontSize: "18px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                    }}
                    className="btn mb-3 landing-button"
                  >
                    Class 9 <br></br>IA Practical
                  </a>
                </div>
                <div className="col-md-3">
                  <div style={{ marginTop: "15px", marginLeft: "10px" }}></div>
                  <a
                    href=""
                    style={{
                      height: "100px",
                      fontSize: "18px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                    }}
                    className="btn mb-3 landing-button"
                  >
                    Class 10<br></br> IA Portal
                  </a>
                </div> */}
                    {/* <div className="col-md-3">
                  <div style={{ marginTop: "15px", marginLeft: "10px" }}></div>
                  <a
                    href="https://scrtny10.jacexamonline.com/"
                    style={{
                      height: "100px",
                      fontSize: "18px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                    }}
                    className="btn mb-3 landing-button"
                  >
                    Secondary Scrutiny<br></br> Portal
                  </a>
                </div> */}
                    {/* <div className="col-md-9">
                  <div className="card box-shadow">
                    <div
                      className="card-header"
                      style={{
                        color: "black",
                        backgroundColor: "white",
                        padding: "20px",
                      }}
                    >
                      <h3 style={{ marginBottom: "0px" }}>Our Notices</h3>
                    </div>
                    <div className="card-body">
                      <div
                        style={{
                          backgroundColor: "white",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                          borderRadius: "8px",
                          padding: "16px",
                          border: "1px solid #e5e7eb",
                        }}
                      >
                        {Array.isArray(notices) &&
                          notices.map((notice, index) => {
                            return (
                              <div className="notice-item" key={index}>
                                <div className="notice-left">
                                  <div className="notice-date">
                                    <div className="notice-new-badge">New</div>
                                    <div className="notice-day">
                                      {notice.showinG_DATE.split("-")[0]}
                                    </div>
                                    <div className="notice-month">
                                      {notice.showinG_DATE &&
                                        new Date(
                                          notice.showinG_DATE
                                            .split("-")
                                            .reverse()
                                            .join("-")
                                        ).toLocaleString("default", {
                                          month: "short",
                                          year: "numeric",
                                        })}
                                    </div>
                                  </div>
                                  <div className="notice-text">
                                    {notice.noticE_DESCRIPTION}
                                  </div>
                                </div>

                                <div className="notice-pdf-info">
                                  <span>
                                    (
                                    {fileSizes[index]
                                      ? `${fileSizes[index]} KB`
                                      : "0.00 KB"}
                                    )
                                  </span>
                                  <a
                                    href={
                                      notice.noticE_FILE_URL
                                        ? notice.noticE_FILE_URL
                                        : `${process.env.PUBLIC_URL}/assets/images/no-image.png`
                                    }
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    title="View PDF & Download"
                                  >
                                    <MdDownloadForOffline
                                      style={{
                                        fontSize: "22px",
                                        cursor: "pointer",
                                      }}
                                    />
                                  </a>
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  </div>
                </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer
          style={{ padding: 10, backgroundColor: "#4469BA", color: "white" }}
        >
          <div
            className="container"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <p style={{ marginBottom: 0 }}>
              Copyright © JAC. All rights reserved.
            </p>
            <p style={{ marginBottom: 0 }}>
              Report any problems or questions to{" "}
              <a
                href="mailto:jac.form.helpdesk@gmail.com"
                style={{ textDecoration: "none", color: "white" }}
              >
                ithelp.jac@gmail.com
              </a>
            </p>
          </div>
        </footer>
      </div>
    </>
  );
}

export default SecondaryLanding;
